/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RoutesDispatchedDtoBase
 * auto generated base class for the model RoutesDispatchedDtoModel.
 */
export const RoutesDispatchedDtoModelBase = ModelBase
  .named('RoutesDispatchedDto')
  .props({
    __typename: types.optional(types.literal("RoutesDispatchedDto"), "RoutesDispatchedDto"),
    routeIds: types.union(types.undefined, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RoutesDispatchedDtoModelSelector extends QueryBuilder {
  get routeIds() { return this.__attr(`routeIds`) }
}
export function selectFromRoutesDispatchedDto() {
  return new RoutesDispatchedDtoModelSelector()
}

export const routesDispatchedDtoModelPrimitives = selectFromRoutesDispatchedDto().routeIds
